const storeName = 'PEERIUS';
export default {
    SET_PEERIUS_DATA: `${storeName}.SET_PEERIUS_DATA`,
    CLEAR_PEERIUS_DATA: `${storeName}.CLEAR_PEERIUS_DATA`,
    SET_RECOMMENDATIONS_BY_WIDGETS: `${storeName}.SET_RECOMMENDATIONS_BY_WIDGETS`,
    SET_SMART_CONTENT: `${storeName}.SET_SMART_CONTENT`,
    SEND_IMPRESSIONS: `${storeName}.SEND_IMPRESSIONS`,
    SEND_CLICK: `${storeName}.SEND_CLICK`,
    SEND_CONTENT_CLICK: `${storeName}.SEND_CONTENT_CLICK`,
};
